/* Vanda's Kitchen: first-party attribution. 2026-10-07.
   1) Remembers HOW a visitor first arrived, but ONLY after analytics consent (UK PECR / Shopify Customer Privacy API).
   2) Offers an optional one-tap "How did you find us?" on the cart page (user-initiated, stored in memory only).
   3) Exposes window.vkAttribution(): the controller adds these to the cart attributes when it saves delivery details,
      so they appear on the order under "Additional details". No third-party service, nothing sent anywhere else. */
(function () {
  var KEY = 'vk_ft_v1', TTL = 30 * 864e5;
  var chosen = '';

  function allowed() {
    try { return !!(window.Shopify && Shopify.customerPrivacy && Shopify.customerPrivacy.analyticsProcessingAllowed()); }
    catch (e) { return false; }
  }

  function label(utm, host) {
    var s = (utm || '').toLowerCase(), h = (host || '').toLowerCase();
    var t = s || h;
    if (!t) return 'Direct or unknown';
    if (/chatgpt|openai/.test(t)) return 'ChatGPT';
    if (/perplexity/.test(t)) return 'Perplexity';
    if (/gemini|bard/.test(t)) return 'Gemini';
    if (/copilot/.test(t)) return 'Copilot';
    if (/claude|anthropic/.test(t)) return 'Claude';
    if (/google/.test(t)) return 'Google';
    if (/bing/.test(t)) return 'Bing';
    if (/duckduckgo|yahoo|ecosia/.test(t)) return 'Other search engine';
    if (/linkedin|lnkd/.test(t)) return 'LinkedIn';
    if (/facebook|instagram|fb\.|l\.instagram|meta/.test(t)) return 'Facebook or Instagram';
    if (/whatsapp|wa\.me/.test(t)) return 'WhatsApp';
    if (/tiktok/.test(t)) return 'TikTok';
    if (/mail|newsletter|email|outlook/.test(t)) return 'Email';
    return s ? 'Campaign: ' + s.slice(0, 40) : 'Referral: ' + h.slice(0, 40);
  }

  function capture() {
    if (!allowed()) return;
    try {
      var cur = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (cur && Date.now() - cur.t < TTL) return;
      var p = new URLSearchParams(location.search), host = '';
      try { host = document.referrer ? new URL(document.referrer).hostname.replace(/^www\./, '') : ''; } catch (e) {}
      if (/(^|\.)vandaskitchen\.co\.uk$/.test(host)) host = '';
      var rec = { t: Date.now(), src: label(p.get('utm_source'), host), host: host.slice(0, 60), utm: [p.get('utm_source'), p.get('utm_medium'), p.get('utm_campaign')].filter(Boolean).join(' / ').slice(0, 80), land: location.pathname.slice(0, 120) };
      localStorage.setItem(KEY, JSON.stringify(rec));
    } catch (e) {}
  }

  window.vkAttribution = function () {
    var out = {};
    if (chosen) out['How they found us'] = chosen;
    if (allowed()) {
      try {
        var r = JSON.parse(localStorage.getItem(KEY) || 'null');
        if (r && Date.now() - r.t < TTL) {
          out['Source'] = r.src;
          if (r.utm || r.host) out['Source detail'] = (r.utm || r.host);
          if (r.land) out['First landing page'] = r.land;
        }
      } catch (e) {}
    }
    return out;
  };

  /* ---- optional cart question (cart page only) ---- */
  var OPTIONS = ['Google search', 'ChatGPT or another AI assistant', 'Recommended by someone', 'A message from you', 'Saw you at a building or delivery', 'Other'];
  function css() {
    if (document.getElementById('vkf-css')) return;
    var s = document.createElement('style'); s.id = 'vkf-css';
    s.textContent = '#vk-found{margin:10px 0 0;padding:0 4px;font-size:13px}#vk-found .vkf__toggle{background:none;border:0;padding:8px 0;color:#106537;text-decoration:underline;cursor:pointer;font:inherit;font-size:13px;min-height:44px}#vk-found .vkf__chips{display:flex;flex-wrap:wrap;gap:8px;padding:4px 0 8px}#vk-found .vkf__chip{border:1.5px solid #106537;background:#fff;color:#106537;border-radius:999px;padding:9px 14px;min-height:40px;font:inherit;font-size:13px;font-weight:600;cursor:pointer}#vk-found .vkf__chip[aria-pressed="true"]{background:#106537;color:#fff}#vk-found .vkf__thanks{color:#106537;font-weight:600;padding:6px 0}';
    document.head.appendChild(s);
  }
  function build() {
    var w = document.createElement('div'); w.id = 'vk-found';
    var b = document.createElement('button'); b.type = 'button'; b.className = 'vkf__toggle'; b.setAttribute('aria-expanded', 'false'); b.textContent = 'Optional: how did you find us?';
    var c = document.createElement('div'); c.className = 'vkf__chips'; c.hidden = true; c.setAttribute('role', 'group'); c.setAttribute('aria-label', 'How did you find us? (optional)');
    OPTIONS.forEach(function (o) {
      var x = document.createElement('button'); x.type = 'button'; x.className = 'vkf__chip'; x.setAttribute('aria-pressed', 'false'); x.textContent = o;
      x.addEventListener('click', function () {
        var was = x.getAttribute('aria-pressed') === 'true';
        [].forEach.call(c.querySelectorAll('.vkf__chip'), function (y) { y.setAttribute('aria-pressed', 'false'); });
        chosen = was ? '' : o; if (!was) x.setAttribute('aria-pressed', 'true');
        var t = w.querySelector('.vkf__thanks'); if (t) t.hidden = !chosen;
      });
      c.appendChild(x);
    });
    var t = document.createElement('div'); t.className = 'vkf__thanks'; t.hidden = true; t.textContent = 'Thank you.'; t.setAttribute('role', 'status');
    b.addEventListener('click', function () { var open = c.hidden; c.hidden = !open; b.setAttribute('aria-expanded', String(open)); });
    w.appendChild(b); w.appendChild(c); w.appendChild(t); return w;
  }
  function mountCart() {
    if (!/^\/cart\/?$/.test(location.pathname)) return;
    css();
    var block = null;
    function place() {
      var ctrl = document.getElementById('vk-checkout-controller');
      /* The controller first creates its panel at the end of the page and later moves it into the cart summary column.
         Only attach once it is inside the summary column, and follow it if it moves again. */
      if (!ctrl || !ctrl.closest('.cart__summary-inner')) return;
      if (!block) block = build();
      if (ctrl.nextElementSibling !== block) ctrl.insertAdjacentElement('afterend', block);
    }
    place();
    var mo = new MutationObserver(place);
    mo.observe(document.body, { childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 180000);
  }

  /* ---- Microsoft Clarity masking: hide personal details in session recordings, whatever the Clarity dashboard says.
     Clarity honours data-clarity-mask="True" on an element and everything inside it. ---- */
  var MASK_ROOTS = '#vk-checkout-controller, .vkcc, #vk-chat-root, #vk-dash-content, #vk-dash-loading, .vk-dash, form[action*="/account"], form[action*="/contact"], form[action*="/customer"]';
  var MASK_FIELDS = 'input:not([type=hidden]):not([type=checkbox]):not([type=radio]):not([type=submit]):not([type=button]):not([type=number]):not([type=search]), textarea';
  function maskSensitive() {
    try {
      [].forEach.call(document.querySelectorAll(MASK_ROOTS + ', ' + MASK_FIELDS), function (e) {
        if (e.getAttribute('data-clarity-mask') !== 'True') e.setAttribute('data-clarity-mask', 'True');
      });
    } catch (e) {}
  }
  function startMasking() {
    maskSensitive();
    var t = null, mo = new MutationObserver(function () { if (t) return; t = setTimeout(function () { t = null; maskSensitive(); }, 150); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
  }

  function init() {
    startMasking();
    mountCart();
    if (!(window.Shopify && Shopify.loadFeatures)) return;
    Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
      if (err) return;
      capture();
      document.addEventListener('visitorConsentCollected', capture);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
